import api from '../../services/api';
import { Creators } from '../ducks/rec_customer_content';
import { call, put } from 'redux-saga/effects';
import { actions as toastrActions } from 'react-redux-toastr';
import { captureSentryException } from '../../utils';

export function* getRecCustomerContent({ id }) {
  try {

    yield put(Creators.recCustomerContentRequest());
    const response = yield call(api.post, 'rec-customer-content', { id });

    yield put(Creators.recCustomerContentTopRecommendations(response.data.items));
    yield put(Creators.recCustomerContentSuccess(response.data));
  } catch (err) {
    yield captureSentryException(err, id);
    yield put(Creators.recCustomerContentError({ err }));
    yield put(toastrActions.add({
      type: 'error',
      title: 'Erro',
      message: 'Falha ao listar recomendação de conteúdos por clientes'
    }));
  }
}